let loginStatusPromise = null;

function fetchLoginStatus() {
	return fetch('/api/v1/signinstate/current/', {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			'Cache-Control': 'no-cache',
		}
	}).then(response => {
		if (!response.ok) throw new Error('Failed to fetch login status');
		return response.json();
	});
}

function getLoginStatus() {
	if (typeof window !== 'undefined' && window.loginStatusReady && window.loginStatus) {
		return Promise.resolve(window.loginStatus);
	}

	if (!loginStatusPromise) {
		loginStatusPromise = fetchLoginStatus()
			.then(data => {
				const result = {
					isLoggedIn: data.isLoggedIn,
					crn: data.crn || '',
					numberForLife: data.numberForLife || '',
					tags: data.tags || [],
					loggedInLinks: data.loggedInLinks || []
				};

				if (typeof window !== 'undefined') {
					window.loginStatus = result;
					window.loginStatusReady = true;
				}

				return result;
			});
	}

	return loginStatusPromise;
}

module.exports = {
	getLoginStatus,
};


// WEBPACK FOOTER //
// ./src/common/Logon/Logon.js